import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { Colaborador } from "../../../services/Colaborador";
import { IColaboradorForm } from "../../../types/colaborador";
import { TipoColaboradorEnum } from "../../../enums/tipoColaborador";
import { useNavigate } from "react-router-dom";
import { FormCollaboratorRegisterValues } from "../../Molecules/FormCollaboratorRegister/useFormCollaboratorRegister";

export const useCollaboratorRegister = () => {
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();

  function onSubmit(data: FormCollaboratorRegisterValues) {
    setIsLoad(true);

    const PAYLOAD: IColaboradorForm = {
      cpf: data.cpf,
      nome: data.nome,
      email: data.email,
      telefone: data.telefone,
      tipo: data.tipo as TipoColaboradorEnum,
      perfis: data.perfis?.map((i) => i.value),
      uuidLojas: data.uuidLojas?.map((i) => i.value),
      uuidDeliverys: data.uuidDeliverys?.map((i) => i.value),
      ativo: false,
    };

    Colaborador.post(PAYLOAD)
      .then(() => {
        toast.success("Colaborador cadastrado com sucesso");
        navigate("/configuracoes/colaboradores");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }
  return { onSubmit };
};
